import { useEffect, useState } from 'react';

import { Select, Spin } from 'antd';

interface EmailTemplate {
  id: string;
  name: string;
  from_name?: string;
  from_email?: string;
}

interface EmailTemplateSelectProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  type?: string;
}

export const EmailTemplateSelect = ({
  value,
  onChange,
  placeholder = 'Select email template',
  type = '',
}: EmailTemplateSelectProps) => {
  const [templates, setTemplates] = useState<EmailTemplate[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTemplates = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch('/api/execute-query', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            screenKey: 'email_transactional_email_template',
            queryName: 'email_getemailtemplates',
            options: {
              vars: {
                page: 1,
                limit: 100,
                name: '',
                type,
                campaign_code: '',
                search: '',
              },
            },
          }),
        });

        if (!response.ok) {
          throw new Error('Failed to fetch email templates');
        }

        const data = await response.json();
        const templateList = data?.results || [];
        setTemplates(templateList);
      } catch (err) {
        console.error('Error fetching email templates:', err);
        setError('Failed to load email templates');
      } finally {
        setLoading(false);
      }
    };

    fetchTemplates();
  }, [type]);

  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      loading={loading}
      notFoundContent={loading ? <Spin size="small" /> : 'No templates found'}
      showSearch
      optionFilterProp="label"
      filterOption={(input, option) =>
        String(option?.label ?? '')
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      disabled={loading || !!error}
      status={error ? 'error' : undefined}
    >
      {templates.map(template => (
        <Select.Option key={template.id} value={template.id} label={template.name}>
          {template.name}
          {template.from_email && (
            <span style={{ color: '#999', marginLeft: 8, fontSize: '12px' }}>
              {template.from_email}
            </span>
          )}
        </Select.Option>
      ))}
    </Select>
  );
};
